module.exports = __webpack_public_path__ + "static/leo-0100e8307bb5db85e1aae854a66ba65a.png";